// src/components/OrderSummary.js
import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  Container,
  Button,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  Modal,
  TextField,
  IconButton,
  Tooltip,
  MenuItem,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  convertPrimaryOrderToSecondaryOrderAction,
  getCompanySuppliersAction,
  getOrderBookingPaginatedAction,
  getPoOrderDetailsAction,
  sellViaInventoryInvoicingAction,
  updateDirectPaymentStatusAction,
  updateOrderDetailsAction,
} from './Action';
import moment from 'moment';
import {
  OperationType,
  OrderBookingApprovalStatusOfCompanyAdmin,
  SupplierModuleTypeEnum,
  getOrderFinalStatusById,
  newSecondaryIndustryTypeArr,
  orderStatusmap,
  paymentStatusObject,
} from '../../utils/settings';
import StatusStickerComponent from '../Components/StatusStickerComponent';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Spin } from 'antd';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteIcon from '@mui/icons-material/Delete';
import AddRemoveQty from '../Components/AddRemoveQty';
import MouseOverPopover from '../MyAccount/Container/HoverPopover';
import { GetDownloadFileAction } from '../../screen/distributor/action/util_action';
import { deleteOrderAction } from '../../screen/distributor/action/easebuzz_utils';
import OrderSummaryInfo from './Components/OrderSummaryInfo';
import { DeleteOutlineRounded, SystemUpdateAlt } from '@mui/icons-material';
import { searchProducts } from '../APIs/action';

const itemCount = 1000;
const DispatchStatusDetails = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [orderBookingsList, setOrderBookingsList] = useState([]);
  const [openPOListDialog, setOpenPOListDialog] = useState(false);
  const [selectedPO, setSelectedPO] = useState({});

  const [open, setOpen] = useState(false);

  const handleModalOpen = () => setOpen(true);
  const handleModalClose = () => {
    setOpen(false);
  };

  const getOrderDetails = async (orderID) => {
    setLoading(true);
    const { data, error, message } = await getPoOrderDetailsAction({
      order_id: orderID,
    });

    setLoading(false);

    if (!error) {
      dispatch({
        type: 'SET_EDIT_PO_BOOKING_DETAILS',
        data: data,
      });
    } else {
      return toast.error(message);
    }
  };

  const orderPaginated = async () => {
    const config = new URLSearchParams();
    config.append('f', 'id$gte$0');
    config.append('o', 'id$desc');
    config.append('is_buyer', true);
    config.append(
      'f',
      `seller_id$eq$${booking_editorder_details.order_details.supplier_id}`,
    );
    config.append('f', `po_approval_status$eq$APPROVED`);

    const { data, error, message } = await getOrderBookingPaginatedAction(
      config,
    );

    if (!error) {
      const list = data.filter(
        (item) =>
          item?.booking_details.reduce(
            (acc, curr) => acc + curr.remaining_quantity.quantity_in_metric_ton,
            0,
          ) >=
          booking_editorder_details.quantity_summary.pending
            .quantity_in_metric_ton,
      );
      setOrderBookingsList([...list]);
    } else {
      return toast.error(message);
    }
  };

  const handlePOAllocationCLick = (po) => {
    setOpenPOListDialog(true);
    orderPaginated();
  };

  const convertPrimaryOrderToSecondaryOrder = async () => {
    const obj = {
      order_ids: [booking_editorder_details.order_details.id],
      order_booking_id: selectedPO.booking_id,
      seller_id: booking_editorder_details.order_details.supplier_id,
    };
    const { error, message } = await convertPrimaryOrderToSecondaryOrderAction(
      obj,
    );
    if (!error) {
      toast.success('Order is successfully converted to secondary order');
      navigate('/order-booking/dispatch-status-list');
    } else {
      return toast.error(message);
    }
  };

  const { isSecondaryOrder, booking_editorder_details, companyDetails } =
    useSelector((state) => {
      return {
        addedUserList: state.bcmOrderReducer.addedUserList,
        booking_details: state.bcmOrderReducer.booking_details,
        isSecondaryOrder: state.bcmOrderReducer.isSecondaryOrder,
        seller_id: state.bcmOrderReducer.seller_id,
        booking_editorder_details:
          state.bcmOrderReducer.booking_editorder_details,
        companyDetails: state.fmcgReducer.companyDetails,
      };
    });
  const allowEdit =
    getOrderFinalStatusById('PENDING').name ===
    booking_editorder_details?.order_details?.final_status;

  const handleRejectApproveAction = async (status) => {
    let payload = {
      order_id: booking_editorder_details.order_details.id,
      order_payment_status: status,
    };

    const { error, message } = await updateDirectPaymentStatusAction(payload);

    if (!error) {
      toast.success(
        `Secondary Order ${
          paymentStatusObject['CREDIT_APPROVED'] === status
            ? 'Approved'
            : 'Cancelled'
        } Successfully`,
      );
      getOrderDetails(state.orderID);
    } else {
      toast.error(message);
    }
  };

  useEffect(() => {
    if (selectedPO?.booking_id) {
      convertPrimaryOrderToSecondaryOrder();
    }
  }, [selectedPO]);

  const onSellViaInventory = async () => {
    const obj = {
      order_status: 2,
      send_notification: true,
      so_id:
        booking_editorder_details.shipment_details[0].ship_to_party_info.so_id,
      invoice_products_delivery:
        booking_editorder_details.shipment_details[0].product_summary_info.map(
          (item) => {
            return {
              product_id: item.product_id,
              quantity: {
                quantity_in_bags: item.pending.quantity_in_bags,
                quantity_in_metric_ton: item.pending.quantity_in_metric_ton,
                multiplier: item.pending.multiplier,
                unit: item.pending.unit,
                base_unit: item.pending.base_unit,
              },
              deliver_to:
                booking_editorder_details.shipment_details[0].ship_to_party_info
                  .company_info.id,
            };
          },
        ),
      dispatch_date: moment().format('YYYY-MM-DD'),
    };

    const { error, message } = await sellViaInventoryInvoicingAction(obj);
    if (!error) {
      toast.success('order is successfully fulfilled from inventory');
      navigate('/order-booking/secondar-orders-list');
    } else return toast.error(message);
  };

  const onEditDetails = (item) => {
    const obj = {
      company_name: item?.ship_to_party_info?.company_info.name,
      gstin: item?.ship_to_party_info?.company_info?.gst,
      company_id: item?.ship_to_party_info?.company_info.id,
      company_phone_no: item?.ship_to_party_info?.company_info.phone,
      company_address: item?.ship_to_party_info?.address_info.address,
      company_pincode: item?.ship_to_party_info?.address_info.pincode,
      district_id: item?.ship_to_party_info?.district_info.id,
      state_id: item?.ship_to_party_info?.state_info.id,
      state_name: item?.ship_to_party_info?.state_info.name,
      delivery_Address_line1:
        item?.ship_to_party_info?.address_info.address.address_line_1,
      delivery_Address_line2:
        item?.ship_to_party_info?.address_info.address.address_line_2,
      delivery_Address_line3:
        item?.ship_to_party_info?.address_info.address.address_line_3,
      delivery_company_pincode: item?.ship_to_party_info?.address_info.pincode,
      delivery_location_id: item?.ship_to_party_info?.location_info.location_id,
      delivery_location_name:
        item?.ship_to_party_info?.location_info?.location_name,
      delivery_pricing_geography_id:
        item?.ship_to_party_info?.pricing_geography_info.pricing_geography_id,
      delivery_pricing_geography_name:
        item?.ship_to_party_info?.pricing_geography_info.pricing_geography_name,
      delivery_district_id: item?.ship_to_party_info?.district_info.id,
      delivery_district_name: item?.ship_to_party_info?.district_info.name,
      delivery_type: item?.ship_to_party_info?.delivery_info.delivery_type,
      incoterms: item?.ship_to_party_info?.delivery_info.incoterms,
      dispatch_date:
        item?.ship_to_party_info?.delivery_info?.requested_dispatch_date,
      delivery_contact_person_name:
        item?.ship_to_party_info?.contact_person_info?.name,
      delivery_contact_person_phone:
        item?.ship_to_party_info?.contact_person_info?.phone_number,
      ...item,
    };

    navigate('/order-booking/ship-to-party-details', {
      state: {
        editUserData: obj,
        isFromEditOrderDetails: true,
      },
    });
  };

  const onFinish = async () => {
    const payload = {
      order_id: booking_editorder_details?.order_details?.id,
      order_products_delivery: booking_editorder_details?.shipment_details.map(
        (item) => ({
          ship_to_party_info: {
            so_id: item?.ship_to_party_info?.so_id,
            operation_type: item?.ship_to_party_info?.operation_type || null,
            deliver_to: item?.ship_to_party_info?.company_info.id,
            company_name: item?.ship_to_party_info?.company_info.name,
            delivery_address: item?.ship_to_party_info?.address_info?.address,
            order_product_delivery_type:
              item?.ship_to_party_info?.delivery_info.delivery_type,
            order_delivery_contact_no:
              item?.ship_to_party_info?.contact_person_info?.phone_number,
            order_delivery_contact_person_name:
              item?.ship_to_party_info?.contact_person_info?.name,
            requested_district_id: item?.ship_to_party_info?.district_info?.id,
            requested_dispatch_date:
              item?.ship_to_party_info?.delivery_info?.requested_dispatch_date,
            requested_pincode: item?.ship_to_party_info?.address_info?.pincode,
            location_id: item?.ship_to_party_info?.location_info?.location_id,
            pricing_geography_id:
              item?.ship_to_party_info?.pricing_geography_info
                ?.pricing_geography_id,
          },
          products_info: item?.product_summary_info.map((prod) => ({
            order_product_delivery_id: prod?.order_product_delivery_id || null,
            operation_type: prod?.operation_type || null,
            product_id: prod?.product_id,
            quantity: {
              // quantity_in_bags: 0,
              quantity_in_metric_ton: Number(
                prod?.pending?.quantity_in_metric_ton,
              ),
              multiplier: prod?.pending?.multiplier,
              units: prod?.pending?.units,
            },
            form_type: prod?.form_type,
            bundle: prod?.bundle,
            length: prod['length'],
            remark: prod?.remark,
          })),
        }),
      ),
    };

    if (
      payload.order_products_delivery.filter(
        (item) =>
          item.ship_to_party_info.operation_type !== OperationType['DELETE'],
      ).length === 0
    )
      return toast.error('Please add atleast one STP');

    setLoading(true);
    const { error, message } = await updateOrderDetailsAction(payload);
    setLoading(false);

    if (!error) {
      toast.success('Order Updated Successfully');
    } else {
      toast.error(message);
    }

    getOrderDetails(booking_editorder_details?.order_details?.id);
  };

  const onDelete = (item) => {
    dispatch({
      type: 'REMOVE_USER_EDIT_PO_BOOKING_DETAILS',
      data: item,
    });
  };
  const onQuantityChange = (operation, item, ship_to_party_id, inputVal) => {
    const shipToPartyIndex =
      booking_editorder_details?.shipment_details?.findIndex(
        (s) => s.ship_to_party_info.company_info.id === ship_to_party_id,
      );
    if (shipToPartyIndex === -1) {
      return console.error('ShipToParty not found:', ship_to_party_id);
    }

    const shipToParty = {
      ...booking_editorder_details.shipment_details[shipToPartyIndex],
    };
    const productIndex = shipToParty.product_summary_info.findIndex(
      (i) => i.product_id === item.product_id,
    );

    if (productIndex === -1) {
      return console.error('Product not found:', item.product_id);
    }

    const product = { ...shipToParty.product_summary_info[productIndex] };

    if (operation === 'delete') {
      product.operation_type = OperationType['DELETE'];
    } else {
      const finalQty =
        operation === 'add'
          ? Number(product.pending.quantity_in_metric_ton) + 1
          : operation === 'input'
          ? Number(inputVal)
          : Number(product.pending.quantity_in_metric_ton) - 1;

      if (finalQty <= 0) {
        return toast.error('Quantity cannot be zero');
      }

      product.pending.quantity_in_metric_ton = finalQty;
      product.operation_type =
        product.operation_type === OperationType['ADD']
          ? OperationType['ADD']
          : OperationType['UPDATE'];
    }

    shipToParty.product_summary_info[productIndex] = product;
    dispatch({
      type: 'UPDATE_PRODUCT_EDIT_PO_BOOKING_DETAILS',
      data: shipToParty,
    });
  };

  const invoiceFileType = {
    invoice: 'invoice',
    test_certificate: 'test_certificate',
  };
  const downloadHandler = async (fileType, invoiceDetails) => {
    const files = invoiceDetails.filter((item) => item.file_type === fileType);

    if (files.length <= 0) {
      return toast.error(
        `No ${
          invoiceFileType['invoice'] === fileType
            ? 'Invoice Files'
            : 'Test Certificates'
        } Available`,
      );
    }

    files.map(
      async (item) =>
        await GetDownloadFileAction(
          item.invoice_file_id,
          item.filename,
          item.file_type,
        ),
    );
  };

  const onDeleteDP = async () => {
    const { error, message } = await deleteOrderAction(
      booking_editorder_details?.order_details?.id,
    );

    if (!error) {
      toast.success('Order Deleted Successfully');
      navigate(-1);
    } else {
      toast.error(message);
    }
  };

  const deletePoModal = (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          height: 300,
          bgcolor: 'background.paper',
          borderRadius: 5,
          boxShadow: 24,
          p: 4,
          justifyContent: 'center',
        }}
      >
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
          sx={{
            fontWeight: 'bold',
            color: '#000000',
            marginTop: '1rem',

            textAlign: 'center',
          }}
        >
          Are you sure you want to Delete This Dispatch Plan?
        </Typography>

        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          sx={{ marginTop: '3rem' }}
        >
          <Button
            variant='outlined'
            color='success'
            onClick={() => handleModalClose()}
          >
            No
          </Button>
          <Button
            variant='outlined'
            color='error'
            onClick={() => onDeleteDP()}
          >
            Delete Plan
          </Button>
        </Stack>
      </Box>
    </Modal>
  );

  const companyId = booking_editorder_details?.order_details?.supplier_id;
  const checkIndustryType = () => {
    setIsFmcg(result.sub_industry_id === newSecondaryIndustryTypeArr['FOOD']);
    setIsPaint(
      result.sub_industry_id ===
        newSecondaryIndustryTypeArr['PAINT_AND_HARDWARE'],
    );
    setIsCement(
      result.sub_industry_id === newSecondaryIndustryTypeArr['CEMENT'],
    );
  };

  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [selectedProductList, setSelectedProductList] = useState([]);
  const [productListData, setProductListData] = useState([]);
  const [formData, setFormData] = useState({
    subProduct: '',
    quantity: '',
  });
  const [companyType, setCompanyType] = useState([]);
  const [result, setResult] = useState(null);
  const [isFmcg, setIsFmcg] = useState(false);
  const [isPaint, setIsPaint] = useState(false);
  const [isCement, setIsCement] = useState(false);

  const [selectedSTP, setSelectedSTP] = useState(null);

  const getCompany = async () => {
    const { data, error } = await getCompanySuppliersAction(
      SupplierModuleTypeEnum.dp_history_enabled,
    );
    if (!error) {
      setCompanyType(data);
    }
  };
  const getInitialAllProducts = async () => {
    let params = {
      query: {
        match: {
          company_id: {
            query: companyId,
          },
        },
      },
      size: itemCount,
    };

    search(params);
  };
  const search = async (params) => {
    let queryParams = {
      search_index: 'sku-master',
    };
    queryParams['pricing_geography_id'] =
      selectedSTP?.ship_to_party_info?.delivery_pricing_geography_id;
    const { data, error } = await searchProducts(params, queryParams);
    if (!error) {
      setProductListData(data.hits);
    } else {
      return toast.error('Error in fetching data');
    }
  };
  useEffect(() => {
    getCompany();
  }, []);

  const getSubIndustryInfoBySupplierId = (supplierId) => {
    for (let industry of companyType) {
      const supplier = industry.suppliers_list.find((s) => s.id === supplierId);
      if (supplier) {
        return {
          sub_industry_id: industry.sub_industry_id,
          sub_industry_name: industry.sub_industry_name,
        };
      }
    }
    return null;
  };
  useEffect(() => {
    if (result) {
      checkIndustryType();
    }
  }, [result]);

  useEffect(() => {
    if (companyType.length > 0) {
      const supplierInfo = getSubIndustryInfoBySupplierId(
        booking_editorder_details?.order_details?.seller_id,
      );
      setResult(supplierInfo);
    }
  }, [companyType]);
  useEffect(() => {
    if (isFmcg || isPaint || isCement) {
      getInitialAllProducts();
    }
  }, [isFmcg, isPaint, isCement]);

  const [errors, setErrors] = useState({});
  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (isFmcg || isPaint || isCement) {
      if (!formData.subProduct) {
        newErrors.subProduct = 'Product is required.';
        valid = false;
      }
      if (!formData.quantity || Number(formData.quantity) <= 0) {
        newErrors.quantity = 'Quantity must be greater than zero.';
        valid = false;
      }
    } else {
      if (!formData.formType) {
        newErrors.formType = 'Form Type is required.';
        valid = false;
      }
    }

    setErrors(newErrors);
    return valid;
  };
  const handleSubmit = () => {
    let temp = {};
    const product = productListData.find((v) => v === formData.subProduct);

    if (!product) {
      alert('Selected product not found!');
      return;
    }

    const productInfo = {
      product_id: product.product_id,
      product_name: product.name,
      product_logo: product.product_logo,
      price: product.meta_data.price.dlp,
      unit: product.meta_data.unit,
      base_unit: product.meta_data.base_unit,
      multiplier: Number(product.meta_data.Case_Size),
    };

    const existingProductIndex = selectedProductList.findIndex(
      (v) => v.product_summary_info.product_id === product.product_id,
    );

    if (existingProductIndex !== -1) {
      // If product already exists, update its quantity
      setSelectedProductList((prevList) =>
        prevList.map((item, index) =>
          index === existingProductIndex
            ? {
                ...item,
                product_summary_info: {
                  ...item.product_summary_info,
                  pending: {
                    ...item.product_summary_info.pending,
                    quantity_in_metric_ton:
                      item.product_summary_info.pending.quantity_in_metric_ton +
                      Number(formData.quantity),
                  },
                },
              }
            : item,
        ),
      );
    } else {
      temp = {
        product_summary_info: {
          ...formData,
          product_id: productInfo.product_id,
          product_name: productInfo.product_name,
          product_logo: productInfo.product_logo,
          price_info: {
            price: 0,
            unit: '',
            gst: 0,
            landing_price_ex_gst: 0,
            total_ex_gst: 0,
          },
          delivered: {
            quantity_in_bags: 0,
            quantity_in_metric_ton: 0,
            multiplier: productInfo.multiplier,
            unit: productInfo.unit,
            base_unit: productInfo.base_unit,
          },
          pending: {
            quantity_in_bags: 0,
            quantity_in_metric_ton: Number(formData.quantity),
            multiplier: productInfo.multiplier,
            unit: productInfo.unit,
            base_unit: productInfo.base_unit,
          },
          product: null,
          formType: null,
          Length: null,
          remark: null,
        },
        operation_type: OperationType['ADD'],
      };

      setSelectedProductList([...selectedProductList, temp]);
    }

    setFormData({
      subProduct: '',
      quantity: '',
    });
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };
  const handleQuantityChange = useCallback(
    (index, value) => {
      const updatedList = [...selectedProductList];
      updatedList[index].quantity = Number(value);
      setSelectedProductList(updatedList);
    },
    [selectedProductList],
  );

  const onAddProdToStp = () => {
    const shipToParty = booking_editorder_details.shipment_details.filter(
      (item) =>
        item.ship_to_party_info.company_info.id ===
          selectedSTP.ship_to_party_info.company_info.id &&
        item.ship_to_party_info.address_info.address.address_line_1 ===
          selectedSTP.ship_to_party_info.address_info.address.address_line_1 &&
        item.ship_to_party_info.address_info.address.address_line_2 ===
          selectedSTP.ship_to_party_info.address_info.address.address_line_2 &&
        item.ship_to_party_info.address_info.address.address_line_3 ===
          selectedSTP.ship_to_party_info.address_info.address.address_line_3 &&
        item.ship_to_party_info.address_info.pincode ===
          selectedSTP.ship_to_party_info.address_info.pincode,
    )[0];
    const obj = {
      ...shipToParty,
      product_summary_info: [
        ...shipToParty.product_summary_info,
        ...selectedProductList.map((product) => ({
          product_id: product.product_summary_info.product_id,
          name: product.product_summary_info.product_name,
          product_logo: product.product_summary_info.product_logo,
          price_info: {
            price: product.product_summary_info.price_info.price,
            unit: product.product_summary_info.price_info.unit,
            gst: product.product_summary_info.price_info.gst || 0,
            landing_price_ex_gst:
              product.product_summary_info.price_info.landing_price_ex_gst || 0,
            total_ex_gst:
              product.product_summary_info.price_info.total_ex_gst || 0,
          },
          delivered: {
            quantity_in_bags: 0,
            quantity_in_metric_ton: 0,
            multiplier: product.product_summary_info.delivered.multiplier,
            unit: product.product_summary_info.delivered.unit || '',
            base_unit: product.product_summary_info.delivered.base_unit,
          },
          pending: {
            quantity_in_bags: 0,
            quantity_in_metric_ton:
              product.product_summary_info.pending.quantity_in_metric_ton,
            multiplier: product.product_summary_info.pending.multiplier,
            unit: product.product_summary_info.pending.unit,
            base_unit: product.product_summary_info.pending.base_unit,
          },
          product: null,
          formType: null,
          Length: null,
          remark: null,
          operation_type: OperationType['ADD'],
        })),
      ],
    };
    dispatch({
      type: 'ADD_PRODUCT_EDIT_PO_BOOKING_DETAILS',
      data: obj,
    });
    setFormData({
      // product: '',
      // lengthmtr: '',
      // formType: '',
      subProduct: '',
      quantity: '',
    });
    setSelectedProductList([]);
  };
  const AddProductModal = (
    <Modal
      open={showAddProductModal}
      onClose={() => {
        setSelectedProductList([]);
        setShowAddProductModal(false);
      }}
      aria-labelledby='add-product-modal'
      aria-describedby='add-product-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '50%',
          maxHeight: '90vh',
          overflowY: 'auto',
          bgcolor: 'background.paper',
          border: '1px solid #ccc',
          boxShadow: 24,
          p: 4,
          borderRadius: '8px',
        }}
      >
        <Typography
          sx={{ fontSize: '20px', fontWeight: 'bold' }}
          mb={2}
        >
          Add Product
        </Typography>
        <TextField
          select
          fullWidth
          label='Products'
          margin='normal'
          value={formData.subProduct}
          required
          onChange={(e) => handleInputChange('subProduct', e.target.value)}
        >
          {productListData?.map((option) => (
            <MenuItem
              key={option.product_id}
              value={option}
            >
              {option.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          type='number'
          fullWidth
          label='Enter Qty'
          margin='normal'
          required
          value={formData.quantity}
          onChange={(e) => handleInputChange('quantity', e.target.value)}
        />

        <Button
          variant='contained'
          onClick={(e) => {
            const isValid = validateForm();
            if (isValid) handleSubmit();
          }}
          fullWidth
          sx={{ mt: 2 }}
        >
          Add Product
        </Button>

        <TableContainer sx={{ mt: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Product Name</TableCell>
                <TableCell>Product Quantity</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedProductList.map((record, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {record.product_summary_info.product_name}
                  </TableCell>
                  <TableCell>
                    <TextField
                      value={
                        record.product_summary_info.pending
                          .quantity_in_metric_ton
                      }
                      onChange={(e) =>
                        handleQuantityChange(index, e.target.value)
                      }
                      type='number'
                      fullWidth
                    />
                  </TableCell>
                  <TableCell>
                    <Tooltip title='Remove Product'>
                      <IconButton
                        onClick={() => {
                          setSelectedProductList((prev) =>
                            prev.filter((_, i) => i !== index),
                          );
                        }}
                      >
                        <DeleteOutlineRounded color='error' />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box
          mt={3}
          display='flex'
          justifyContent='flex-end'
        >
          <Button
            onClick={() => {
              setSelectedProductList([]);
              setShowAddProductModal(false);
            }}
            sx={{ mr: 2 }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setShowAddProductModal(false);
              onAddProdToStp();
            }}
            variant='contained'
          >
            Add
          </Button>
        </Box>
      </Box>
    </Modal>
  );
  return (
    <>
      {deletePoModal}
      {AddProductModal}
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          backgroundColor: '#f5f5f5',
          paddingBottom: '2rem',
        }}
      >
        <Spin spinning={loading}>
          <Stack
            direction={'row'}
            sx={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Row
              style={{
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Typography
                variant='h5'
                style={{ marginBottom: '2rem', fontWeight: 'bold' }}
              >
                Order Details
              </Typography>

              <div>
                {!isSecondaryOrder && allowEdit && (
                  <Button
                    onClick={handleModalOpen}
                    variant='contained'
                    endIcon={<DeleteIcon />}
                    color='error'
                    sx={{
                      height: 30,
                      marginLeft: 'auto',
                      marginRight: 1.5,
                    }}
                  >
                    Delete DP
                  </Button>
                )}

                <Button
                  onClick={() => getOrderDetails(state.orderID)}
                  variant='outlined'
                  endIcon={<RefreshIcon />}
                  sx={{
                    height: 30,
                    marginLeft: 'auto',
                  }}
                >
                  Refresh Details
                </Button>
              </div>
            </Row>
            {isSecondaryOrder && (
              <Grid
                direction={'row'}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                {booking_editorder_details?.order_details
                  ?.order_approval_status ===
                OrderBookingApprovalStatusOfCompanyAdmin['PENDING'] ? (
                  <>
                    <Button
                      variant='outlined'
                      onClick={() => {
                        handleRejectApproveAction(
                          paymentStatusObject['CREDIT_REJECTED'],
                        );
                      }}
                      sx={{
                        marginRight: '2rem',
                        backgroundColor: 'Background',
                        fontWeight: 'bold',
                        width: 150,
                      }}
                    >
                      Reject
                    </Button>

                    <Button
                      variant='contained'
                      onClick={() => {
                        handleRejectApproveAction(
                          paymentStatusObject['CREDIT_APPROVED'],
                        );
                      }}
                      sx={{ fontWeight: 'bold', width: 150 }}
                    >
                      Approve
                    </Button>
                  </>
                ) : (
                  <>
                    {booking_editorder_details?.order_details?.status !==
                      orderStatusmap['DELIVERED'] &&
                      booking_editorder_details?.order_details?.status !==
                        orderStatusmap['REJECTED'] &&
                      !booking_editorder_details?.order_details
                        ?.is_primary_order_created_from_secondary_order && (
                        <>
                          <Button
                            variant='outlined'
                            onClick={() => {
                              onSellViaInventory();
                            }}
                            sx={{
                              marginRight: '2rem',
                              backgroundColor: 'Background',
                              fontWeight: 'bold',
                              width: 200,
                            }}
                          >
                            Sell Via Inventory
                          </Button>

                          {booking_editorder_details?.order_details
                            ?.is_po_allocation_enabled && (
                            <Button
                              variant='contained'
                              onClick={() => {
                                handlePOAllocationCLick();
                              }}
                              sx={{ fontWeight: 'bold', width: 200 }}
                            >
                              PO Allocation
                            </Button>
                          )}
                        </>
                      )}
                  </>
                )}
              </Grid>
            )}
          </Stack>

          <Stack
            direction={'row'}
            sx={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Paper
              elevation={3}
              variant='outlined'
              sx={{
                padding: 2,
                marginBottom: 2,
                borderRadius: '1rem',
                width: '49%',
              }}
            >
              <Stack
                direction={'row'}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Typography
                  variant='h6'
                  sx={{ fontWeight: 'bold' }}
                >
                  Order Details
                </Typography>
                <StatusStickerComponent
                  textStyle={{ fontSize: '0.8rem', fontWeight: 'bold' }}
                  containerStyle={{
                    paddingLeft: '0.5rem',
                    paddingRight: '0.5rem',
                    paddingTop: '0.5rem',
                    paddingBottom: '0.5rem',
                  }}
                  color={
                    getOrderFinalStatusById(
                      booking_editorder_details?.order_details?.final_status,
                    )?.color
                  }
                  title={
                    getOrderFinalStatusById(
                      booking_editorder_details?.order_details?.final_status,
                    )?.name
                  }
                  remark={booking_editorder_details?.order_details?.remark}
                />
              </Stack>
              <Divider sx={{ my: 1 }} />
              <Stack
                direction={'row'}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Typography variant='subtitle1'>Order Date:</Typography>
                <Typography variant='subtitle1'>
                  {moment(
                    booking_editorder_details?.order_details?.date,
                  ).format('DD MMM YYYY')}{' '}
                </Typography>
              </Stack>
              <Stack
                direction={'row'}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Typography variant='subtitle1'>Order ID: </Typography>
                <Typography variant='subtitle1'>
                  {booking_editorder_details?.order_details?.id}{' '}
                </Typography>
              </Stack>{' '}
              <Stack
                direction={'row'}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Typography variant='subtitle1'>Order Total:</Typography>
                <Typography variant='subtitle1'>
                  ₹{' '}
                  {
                    booking_editorder_details?.order_details?.bill_info
                      ?.final_amount
                  }
                </Typography>
              </Stack>
            </Paper>
            <Paper
              elevation={3}
              variant='outlined'
              sx={{
                padding: 2,
                marginBottom: 2,
                borderRadius: '1rem',
                width: '49%',
              }}
            >
              <Typography
                variant='h6'
                sx={{ fontWeight: 'bold' }}
              >
                Quantity Summary
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Stack
                direction={'row'}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Typography variant='subtitle1'>Ordered Quantity:</Typography>
                <Typography variant='subtitle1'>
                  {
                    booking_editorder_details?.quantity_summary?.ordered
                      ?.quantity_in_metric_ton
                  }{' '}
                  {booking_editorder_details?.quantity_summary?.ordered?.unit}
                </Typography>
              </Stack>
              <Stack
                direction={'row'}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Typography variant='subtitle1'>Delivered Quantity:</Typography>
                <Typography variant='subtitle1'>
                  {
                    booking_editorder_details?.quantity_summary?.delivered
                      ?.quantity_in_metric_ton
                  }{' '}
                  {booking_editorder_details?.quantity_summary?.delivered?.unit}
                </Typography>
              </Stack>{' '}
              <Stack
                direction={'row'}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Typography variant='subtitle1'>Pending Quantity:</Typography>
                <Typography variant='subtitle1'>
                  {
                    booking_editorder_details?.quantity_summary?.pending
                      ?.quantity_in_metric_ton
                  }{' '}
                  {booking_editorder_details?.quantity_summary?.pending?.unit}
                </Typography>
              </Stack>
              <Stack
                direction={'row'}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Typography variant='subtitle1'>Cancelled Quantity:</Typography>
                <Typography variant='subtitle1'>
                  {
                    booking_editorder_details?.quantity_summary?.cancelled
                      ?.quantity_in_metric_ton
                  }{' '}
                  {booking_editorder_details?.quantity_summary?.cancelled?.unit}
                </Typography>
              </Stack>
            </Paper>
          </Stack>

          <Row
            style={{
              alignItems: 'center',
              marginTop: 20,
              justifyContent: 'space-between',
              marginBottom: 10,
              width: '100%',
            }}
          >
            <Row>
              <Typography
                variant='h6'
                style={{ marginLeft: 20 }}
              >
                Shipment Details
              </Typography>

              {allowEdit && (
                <Button
                  variant='outlined'
                  onClick={() => {
                    dispatch({
                      type: 'SET_SELLER_ID',
                      data: booking_editorder_details?.order_details
                        ?.supplier_id,
                    });

                    navigate('/order-booking/select-ship-to-party', {
                      state: {
                        isFromEditOrderDetails: true,
                      },
                    });
                  }}
                  startIcon={<AddIcon />}
                  sx={{
                    height: 30,
                    marginLeft: 2,
                  }}
                >
                  Add More Ship To Party
                </Button>
              )}
            </Row>

            {allowEdit && (
              <Button
                onClick={onFinish}
                variant='contained'
                endIcon={<SystemUpdateAlt />}
                sx={{
                  height: 30,
                  marginLeft: 2,
                }}
              >
                Update Details
              </Button>
            )}
          </Row>
          {booking_editorder_details?.shipment_details
            ?.filter(
              (vv) =>
                vv.ship_to_party_info?.operation_type !==
                OperationType['DELETE'],
            )
            .map((shipment, index) => (
              <Box
                key={index}
                id={shipment.ship_to_party_info.company_info.id}
              >
                <Paper sx={{ padding: 3, borderRadius: 2, mb: 3 }}>
                  {console.log('shipment', shipment)}
                  <Row
                    style={{
                      marginBottom: 30,
                    }}
                  >
                    {allowEdit && (
                      <Button
                        onClick={() => onEditDetails(shipment)}
                        variant='outlined'
                        endIcon={<EditIcon />}
                        sx={{
                          height: 30,
                          marginLeft: 'auto',
                        }}
                      >
                        Edit Details
                      </Button>
                    )}

                    {allowEdit && (
                      <Button
                        color='error'
                        onClick={() => onDelete(shipment)}
                        sx={{
                          height: 30,
                          marginLeft: 2,
                        }}
                        variant='contained'
                      >
                        <DeleteIcon />
                      </Button>
                    )}
                    {!allowEdit && shipment?.invoice_info?.length > 0 && (
                      <>
                        <Button
                          onClick={() =>
                            downloadHandler(
                              invoiceFileType['invoice'],
                              shipment?.invoice_info,
                            )
                          }
                          variant='outlined'
                          sx={{
                            height: 30,
                            marginLeft: 'auto',
                          }}
                        >
                          Download Invoice
                        </Button>

                        <Button
                          onClick={() =>
                            downloadHandler(
                              invoiceFileType['test_certificate'],
                              shipment?.invoice_info,
                            )
                          }
                          variant='outlined'
                          sx={{
                            height: 30,
                            marginLeft: 2,
                          }}
                        >
                          Download Test Certificates
                        </Button>
                      </>
                    )}
                  </Row>
                  <Stack
                    direction={'row'}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography variant='subtitle1'>Firm Name: </Typography>
                    <Typography variant='subtitle1'>
                      {shipment?.ship_to_party_info?.company_info?.name}{' '}
                    </Typography>
                  </Stack>
                  <Stack
                    direction={'row'}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography variant='subtitle1'>Phone: </Typography>
                    <Typography variant='subtitle1'>
                      {shipment?.ship_to_party_info?.company_info?.phone}{' '}
                    </Typography>
                  </Stack>
                  <Stack
                    direction={'row'}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography variant='subtitle1'>Address: </Typography>
                    <Typography
                      variant='subtitle1'
                      style={{
                        textAlign: 'right',
                      }}
                    >
                      {[
                        shipment?.ship_to_party_info?.address_info?.address
                          ?.address_line_1,
                        shipment?.ship_to_party_info?.address_info?.address
                          ?.address_line_2,
                        shipment?.ship_to_party_info?.address_info?.address
                          ?.address_line_3,
                        shipment?.ship_to_party_info?.address_info?.pincode,
                      ]
                        .filter(Boolean)
                        .join(', ')}
                    </Typography>
                  </Stack>
                  <Stack
                    direction={'row'}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography variant='subtitle1'>Location: </Typography>
                    <Typography
                      variant='subtitle1'
                      style={{
                        textAlign: 'right',
                      }}
                    >
                      {`${shipment?.ship_to_party_info?.location_info?.location_name}`}
                    </Typography>
                  </Stack>
                  <Stack
                    direction={'row'}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography variant='subtitle1'>
                      Pricing Geography:{' '}
                    </Typography>
                    <Typography
                      variant='subtitle1'
                      style={{
                        textAlign: 'right',
                      }}
                    >
                      {`${shipment?.ship_to_party_info?.pricing_geography_info?.pricing_geography_name}`}
                    </Typography>
                  </Stack>
                  <Stack
                    direction={'row'}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography variant='subtitle1'>
                      Delivery District:{' '}
                    </Typography>
                    <Typography variant='subtitle1'>
                      {shipment?.ship_to_party_info?.district_info?.name}
                    </Typography>
                  </Stack>

                  <Stack
                    direction={'row'}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography variant='subtitle1'>
                      Delivery State:{' '}
                    </Typography>
                    <Typography variant='subtitle1'>
                      {shipment?.ship_to_party_info?.state_info?.name}
                    </Typography>
                  </Stack>
                  <Divider
                    sx={{ height: 2, marginTop: '1rem', marginBottom: '2rem' }}
                  />
                  <Row
                    style={{
                      width: '100%',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginBottom: 20,
                    }}
                  >
                    <Typography variant='h6'>Product Summary</Typography>

                    {allowEdit && (
                      <Button
                        onClick={() => {
                          dispatch({
                            type: 'SET_SELLER_ID',
                            data: booking_editorder_details?.order_details
                              ?.supplier_id,
                          });
                          if (companyDetails.po_config.as_seller.required) {
                            navigate('/order-booking/add-products', {
                              state: {
                                isFromEditOrderDetails: true,
                                ship_to_party_details:
                                  shipment.ship_to_party_info,
                              },
                            });
                          } else {
                            setShowAddProductModal(true);
                            setSelectedSTP(shipment);
                          }
                        }}
                        variant='outlined'
                        startIcon={<AddIcon />}
                        sx={{
                          height: 30,
                          marginLeft: 2,
                        }}
                      >
                        Add Products
                      </Button>
                    )}
                  </Row>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {shipment?.product_summary_keys?.map((key) => (
                            <TableCell
                              sx={{ fontWeight: 'bold' }}
                              align={'center'}
                            >
                              {key}{' '}
                            </TableCell>
                          ))}
                          {allowEdit && (
                            <TableCell
                              sx={{ fontWeight: 'bold' }}
                              align={'center'}
                            >
                              Action
                            </TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {shipment?.product_summary_info
                          ?.filter(
                            (v) => v.operation_type !== OperationType['DELETE'],
                          )
                          .map((product) => (
                            <TableRow>
                              <TableCell align={'center'}>
                                <MouseOverPopover
                                  text={product?.name}
                                  popOverText={product?.remark}
                                />
                              </TableCell>
                              <TableCell align={'center'}>
                                {product?.delivered?.unit}
                              </TableCell>

                              <TableCell align={'center'}>
                                {product?.delivered?.quantity_in_metric_ton}
                              </TableCell>
                              <TableCell
                                align={'center'}
                                sx={
                                  allowEdit
                                    ? {
                                        justifyContent: 'center',
                                        display: 'flex',
                                      }
                                    : {}
                                }
                              >
                                {allowEdit ? (
                                  <AddRemoveQty
                                    onIncreasePress={() => {
                                      onQuantityChange(
                                        'add',
                                        product,
                                        shipment.ship_to_party_info.company_info
                                          .id,
                                      );
                                    }}
                                    onTextChange={(input) => {
                                      onQuantityChange(
                                        'input',
                                        product,
                                        shipment.ship_to_party_info.company_info
                                          .id,
                                        input,
                                      );
                                    }}
                                    onReducePress={() => {
                                      onQuantityChange(
                                        'remove',
                                        product,
                                        shipment.ship_to_party_info.company_info
                                          .id,
                                      );
                                    }}
                                    quantity={
                                      product?.pending?.quantity_in_metric_ton
                                    }
                                  />
                                ) : (
                                  product?.pending?.quantity_in_metric_ton
                                )}
                              </TableCell>
                              <TableCell align='center'>
                                {product.price_info.landing_price_ex_gst > 0
                                  ? `${(product.price_info.gst * 100).toFixed(
                                      0,
                                    )}`
                                  : '-'}
                              </TableCell>
                              <TableCell align='center'>
                                {product.price_info.landing_price_ex_gst > 0
                                  ? `${product?.price_info.unit} ${product?.price_info.landing_price_ex_gst}`
                                  : '-'}
                              </TableCell>
                              <TableCell align='center'>
                                {product.price_info.total_ex_gst > 0
                                  ? `${product?.price_info.unit} ${product?.price_info.total_ex_gst}`
                                  : '-'}
                              </TableCell>
                              {allowEdit && (
                                <TableCell align={'center'}>
                                  <Button
                                    onClick={() =>
                                      onQuantityChange(
                                        'delete',
                                        product,
                                        shipment.ship_to_party_info.company_info
                                          .id,
                                      )
                                    }
                                    endIcon={<DeleteIcon />}
                                  ></Button>
                                </TableCell>
                              )}
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <PurchaseOrdersListDialog
                    open={openPOListDialog}
                    handlePOClick={(po) => {
                      setSelectedPO(po);
                      setOpenPOListDialog(false);
                    }}
                    poList={orderBookingsList}
                    onClose={() => setOpenPOListDialog(false)}
                  />
                </Paper>
              </Box>
            ))}
          <Stack
            direction={'row'}
            sx={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            <OrderSummaryInfo
              data={booking_editorder_details?.order_details?.total_bill_info}
              title={'Total Bill Info'}
            />
          </Stack>
        </Spin>
      </Container>
    </>
  );
};

const PurchaseOrdersListDialog = ({
  open = false,
  handlePOClick = () => {},
  poList = [],
  onClose = () => {},
}) => {
  return (
    <Dialog
      onClose={() => onClose()}
      open={open}
    >
      <DialogTitle>Select Purchase order</DialogTitle>
      <List>
        {poList.map((order, index) => {
          return (
            <ListItem
              disableGutters
              key={order.id}
            >
              <ListItemButton
                variant='text'
                onClick={() => {
                  handlePOClick(order);
                }}
              >
                <Paper sx={{ py: '1rem', px: '1rem', width: '100%' }}>
                  <Stack
                    direction={'row'}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography variant='subtitle1'>User Po ID: </Typography>
                    <Typography
                      variant='subtitle1'
                      sx={{ width: '50%' }}
                    >
                      {order.user_booking_id ? order.user_booking_id : '-'}{' '}
                    </Typography>
                  </Stack>
                  <Stack
                    direction={'row'}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography variant='subtitle1'>Order date: </Typography>
                    <Typography variant='subtitle1'>
                      {moment(order.date).format('DD MMM YYYY')}{' '}
                    </Typography>
                  </Stack>
                  <Stack
                    direction={'row'}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography variant='subtitle1'>
                      Remaining Quantity:{' '}
                    </Typography>
                    <Typography variant='subtitle1'>
                      {
                        order.booking_details[0].remaining_quantity
                          .quantity_in_metric_ton
                      }{' '}
                      {order.booking_details[0].remaining_quantity.unit}
                    </Typography>
                  </Stack>
                  <Stack
                    direction={'row'}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography variant='subtitle1'>Price: </Typography>
                    <Typography variant='subtitle1'>
                      ₹ {order.booking_details[0].booking_price}
                    </Typography>
                  </Stack>
                </Paper>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Dialog>
  );
};

export default DispatchStatusDetails;
